export default {
  data: {
    item: null
  }
}
